import { ReactElement } from 'react'
import { Box } from '@mui/material'

type IconComponent = React.ComponentType<Record<string, never>>

export const renderNavIcon = (IconComp: unknown): ReactElement => {
  const Comp = IconComp as IconComponent
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        color: 'inherit',
        fontSize: 16,
        lineHeight: 1,
        '@media (min-width: 1920px)': {
          fontSize: 18,
        },
        '& svg': {
          width: '1em',
          height: '1em',
          fontSize: 'inherit',
        },
      }}
    >
      <Comp />
    </Box>
  )
}
